import { useMutation } from '@tanstack/react-query';

import type { BlockUserArgs } from '../../../Domain/Users/Services';
import { userService } from '../../../Domain/Users/Services';

const mutationFn = (data: BlockUserArgs) => {
  return userService.blockUser(data);
};

export const useUserBlockMutation = () => {
  return useMutation<unknown, unknown, BlockUserArgs>(mutationFn);
};
